import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7ef7cb92")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "handler" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_5 = {
  key: 0,
  class: "footer"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "headerHandler", {}, undefined, true)
        ])
      ], {}, true)
    ]),
    _createVNode(_component_el_table, _mergeProps({
      data: _ctx.list,
      border: "",
      style: {"width":"100%"},
      onSelectionChange: _ctx.handleSelectionChange
    }, _ctx.childrenProp), {
      default: _withCtx(() => [
        _hoisted_4,
        (_ctx.showSelectColum)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "60",
              type: "selection",
              align: "center"
            }))
          : _createCommentVNode("", true),
        (_ctx.showIndexColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              type: "index",
              label: "序號",
              align: "center",
              width: "80"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + _ctx.page.pageSize * (_ctx.page.currentPage - 1) + 1), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propsList, (propItem) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: propItem.id
          }, propItem, {
            align: "center",
            "show-overflow-tooltip": ""
          }), {
            default: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, propItem.slotName, {
                row: scope.row
              }, () => [
                _createTextVNode(_toDisplayString(scope.row[propItem.prop]), 1)
              ], true)
            ]),
            _: 2
          }, 1040))
        }), 128))
      ]),
      _: 3
    }, 16, ["data", "onSelectionChange"]),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createVNode(_component_el_pagination, {
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange,
              "current-page": _ctx.page.currentPage,
              "page-size": _ctx.page.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.listCount
            }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
          ], {}, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}